import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{
  width: number;
}>`
  width: 100%;
  position: relative;
`;

export const SlideShowWrapper = styled.div<{
  background: string;
  padding?: string;
}>`
  width: 100%;
  background: ${p => p.background};

  padding: ${p => p.padding || '6px 0px'};
  //box-sizing: content-box;

  position: relative;

  overflow: auto;

  ::-webkit-scrollbar {
    display: none;
  }
`;

export const StylePrev = css`
  top: 0;
  left: 0;
  transform: translate(-36%, 0);
  z-index: 10;
`;

export const StyleNext = css`
  top: 0;
  right: 0;
  transform: translate(36%, 0);
  z-index: 10;
`;

export const ButtonWrapper = styled.div<{
  type: string;
}>`
  width: 36px;
  height: 100%;

  position: absolute;
  z-index: 10;

  display: flex;
  align-items: center;
  justify-content: center;
  ${props => (props.type == 'PREV' ? StylePrev : StyleNext)};
`;

export const IconButtonStyles = css`
  width: 36px;
  height: 36px;
  background-color: #ffffff;

  box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
  border: none;

  border-radius: 999px;

  color: ${p => p.theme.colors.text.secondary};

  svg {
    path {
      fill: ${p => p.theme.colors.text.secondary} !important;

      transition: all 0.4s;
    }
  }

  &:hover {
    background-color: ${p => p.theme.colors.white};
    color: ${p => p.theme.colors.primary.main};

    svg {
      path {
        fill: ${p => p.theme.colors.primary.main};
      }
    }
  }

  &:focus {
    background-color: ${p => p.theme.colors.white};
    color: ${p => p.theme.colors.primary.main};
  }
`;
